import { Component, Input } from '@angular/core';

@Component({
  selector: 'evrideo-step-forward-icon',
  templateUrl: './step-forward-icon.component.html',
  styleUrls: ['./step-forward-icon.component.scss'],
})
export class StepForwardIconComponent {
  @Input()
  overrideStyle: Record<string, string> = {};
}
